import script from "./TableData.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableData.vue?vue&type=script&lang=ts&setup=true"

import "./TableData.vue?vue&type=style&index=0&id=4939f358&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4939f358"]])

export default __exports__